import { motion, useInView } from 'framer-motion'
import { useRef } from 'react'
import mostrador from '../../../../Imgs/Home/confident.png'
import mesa from '../../../../Imgs/Home/worker.jpg'
import parqueadero from '../../../../Imgs/Home/parqueadero.png'

function Comfort() {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, amount: 0.2 })

  return (
    <div className="flex justify-center md:w-[100%] bg-[#F8F8F8FB]">
      <div className="w-full px-4 lg:px-12">
        <div ref={ref} className="flex flex-col">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="h-[200px] flex flex-col justify-center md:h-[300px]"
          >
            <h1 className="text-center text-xl text-gray-700 md:text-4xl mx-[10px] font-bold tituloPrincipal">
              Elige el método de entrega de tu orden
            </h1>
            <p className="text-center text-gray-500 md:text-xl mx-[10px] mt-4">
              De esta manera, puedes disfrutar de los productos recién
              elaborados.
            </p>
          </motion.div>
          <nav className="">
            <ul className="grid grid-cols-1 xl:grid-cols-3 gap-24 p-[30px] max-w-[600px] xl:max-w-full mx-auto place-items-center">
              <motion.li
                initial={{ opacity: 0, y: 30 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-center md:text-start shadow-xl flex flex-col relative pt-6 bg-white w-full max-w-[400px]"
              >
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#FF4869] rounded-full flex items-center justify-center text-white font-bold text-xl">
                  1
                </div>
                <img
                  className="mx-auto"
                  src={mostrador}
                  alt=""
                  height={350}
                  width={184}
                />
                <div className="pb-[30px] md:pb-[50px] p-10">
                  <p className="tituloSecundario my-[15px]">
                    Entrega en mostrador
                  </p>
                  <p className="textoGeneral">
                    Los clientes pueden retirar sus productos por el mostrador
                    en el momento que programen su recogida con el restaurante.
                  </p>
                </div>
              </motion.li>
              <motion.li
                initial={{ opacity: 0, y: 30 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="text-center md:text-start shadow-xl flex flex-col relative pt-6 bg-white w-full max-w-[400px]"
              >
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#FF4869] rounded-full flex items-center justify-center text-white font-bold text-xl">
                  2
                </div>
                <img
                  className="mx-auto"
                  src={mesa}
                  alt=""
                  height={350}
                  width={350}
                />
                <div className="pb-[30px] md:pb-[50px] p-10 ">
                  <p className="tituloSecundario my-[15px]">
                    Entrega en la mesa
                  </p>
                  <p className=" textoGeneral">
                    Los clientes pueden elegir una mesa dentro del restaurante
                    para realizar el proceso de pedido indicado el número de
                    mesa.
                  </p>
                </div>
              </motion.li>
              <motion.li
                initial={{ opacity: 0, y: 30 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="text-center md:text-start shadow-xl flex flex-col relative pt-6 bg-white w-full max-w-[400px]"
              >
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#FF4869] rounded-full flex items-center justify-center text-white font-bold text-xl">
                  3
                </div>
                <img
                  className="mx-auto mt-12"
                  src={parqueadero}
                  alt=""
                  height={330}
                  width={300}
                />
                <div className="pb-[30px] md:pb-[50px] p-10">
                  <p className="tituloSecundario pb-2">
                    Entrega en parqueadero
                  </p>
                  <p className="textoGeneral">
                    Si eres de los que prefiere no bajarse del coche, ¡tenemos
                    la solución perfecta! Puedes realizar tu orden y ubicarte en
                    la zona de parqueo exclusiva de Pide y Pasa en el
                    restaurante.
                  </p>
                </div>
              </motion.li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  )
}

export default Comfort
